<template>
<div id="app" class="container">
  <nav class="navbar fixed-top navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" href="#/">Luna Observatory Internet Telescope</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <!--li><router-link to="/search">Search</router-link></li-->
      </ul>
      <form class="form-inline my-2 my-lg-0">
        <template v-if="session.user">
        {{ session.user.displayName }} ({{ session.user.email }})
        でログイン中
        &nbsp;
        <b-btn v-b-modal.modalLogout>Logout</b-btn>
        <b-modal id="modalLogout" ref="modal" title="Logout" @ok="handleLogout">
          <div>
            <p>ログアウトします</p>
          </div>
        </b-modal>
        </template>
      </form>
    </div>
  </nav>

  <router-view></router-view>

  <footer style="
      margin-top: 1em;
      font-size: small;
      text-align: center;
      border-width: 1px 0px 0px 0px;
      border-style: solid;
      border-color: #cccccc;
      ">
    &copy; 2018 南阿蘇ルナ天文台
  </footer>
</div>
</template>

<script>
import firebase from "firebase"
import store from './store'

export default {
  name: 'app',
  data() {
    return {
      session: store.state.loginUser.session
    };
  },
  created: function() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        if ( user.providerData.length == 1 && user.providerData.findIndex((profile) => profile.providerId == "password") != -1 && ! user.emailVerified ) {
          this.$router.push({
              name: "emailverification"
          });
          return;
        }
        this.session.setUser(user);
        this.$router.push({
          name: 'home'
        });
      } else {
        this.session.setUser(null);
        this.$router.replace("/");
      }
    });
    if ( ! this.session.user &&
         this.$route.name != "index" &&
         this.$route.name != "emailverification" ) {
      this.$router.replace("/");
    }
  },
  computed: {
  },
  methods: {
    handleLogout() {
      firebase.auth().signOut().then(() => {
        this.$router.push({name: 'index'});
        this.session.user = null
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue